import Vue from "vue";
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
Vue.use(ElementUI);
import textinput from "./textinput/index.vue";
import validatebox from "./validatebox/index.vue";
import combobox from "./combobox/index.vue";
import form from "./form/index.vue";
import datebox from "./datebox/index.vue";
import address from "./address/index.vue";
import telinput from "./telinput/index.vue";
import checkbox from "./checkbox/index.vue";
import fieldset from "./fieldset/index.vue";
require("./message/index");
require("./loading/index");

require("./popup/index");

var components = [textinput, validatebox, combobox, form, datebox, address, telinput, checkbox, fieldset];

var install = function install(Vue) {
  if (install.installed) return;
  components.map(function (component) {
    Vue.component(component.name, component);
  });
};

if (typeof window !== "undefined" && window.Vue) {
  install(window.Vue);
}

export default {
  install: install
};


//////////////////
// WEBPACK FOOTER
// ./src/lib/ui/default/default.js
// module id = 1418
// module chunks = 2